import MicroModal from "micromodal"

const cmpDisclosurePopup = {
	component: null,

	init: function (element) {
		const _ = this
		_.component = element

		const modals = _.component.querySelectorAll(".modal")

		MicroModal.init({
			onShow: (modal) => console.info(`${modal.id} is shown`),
			onClose: (modal) => console.info(`${modal.id} is hidden`),
			openTrigger: "data-custom-open",
			closeTrigger: "data-custom-close",
			openClass: "is-open",
			disableScroll: true,
			disableFocus: false,
			awaitOpenAnimation: false,
			awaitCloseAnimation: false,
			debugMode: false,
		})

		modals.forEach((element) => {
			MicroModal.show(element.id)
      const investorType = element.attributes["data-investor-type"].value
			element.querySelectorAll("[data-custom-dismiss]").forEach((e) => {
				e.addEventListener("click", function (e) {
          if(e.target != e.currentTarget) return
					window.location = _.getRedirectUrl(investorType)
					
				})
			})
		})
	},

  getRedirectUrl: function(investorType) {
    const regex = /[a-zA-Z]+-[a-zA-Z]+/i // two letters (dash) two letters
    const pathArray = window.location.pathname.split('/')
    const countryCode = pathArray[1]
    const isValidCountryCode = regex.test(countryCode)

    if(investorType === undefined) {
      investorType = "guest"
    }

    let redirectUrl = '/' + investorType
    if (isValidCountryCode) {
      redirectUrl = '/' + countryCode + redirectUrl
    } 

    return redirectUrl
  }
}

export default cmpDisclosurePopup
